__turbopack_context__.v({
  "Active": "VideoGallery-module-sass-module__1MXlXW__Active",
  "Cont": "VideoGallery-module-sass-module__1MXlXW__Cont",
  "Details": "VideoGallery-module-sass-module__1MXlXW__Details",
  "Intro": "VideoGallery-module-sass-module__1MXlXW__Intro",
  "Main": "VideoGallery-module-sass-module__1MXlXW__Main",
  "Play": "VideoGallery-module-sass-module__1MXlXW__Play",
  "PlayCont": "VideoGallery-module-sass-module__1MXlXW__PlayCont",
  "Playing": "VideoGallery-module-sass-module__1MXlXW__Playing",
  "Poster": "VideoGallery-module-sass-module__1MXlXW__Poster",
  "Slide": "VideoGallery-module-sass-module__1MXlXW__Slide",
  "Slider": "VideoGallery-module-sass-module__1MXlXW__Slider",
  "VideoGallery": "VideoGallery-module-sass-module__1MXlXW__VideoGallery",
});
